import qs from "qs";
import type { InternalRequestConfig } from "@/api/types";

const pendingRequests = new Map<string, AbortController>();
export function getPendingKey(config: InternalRequestConfig) { return [config.method, config.url, qs.stringify(config.data), qs.stringify(config.params)].join("&"); }

/** 为显式开启 cancel 的请求保留 Vue 版“同参数新请求取消旧请求”语义。 */
export class AxiosCanceler {
    add(config: InternalRequestConfig) { this.remove(config); const controller = new AbortController(); config.signal = controller.signal; pendingRequests.set(getPendingKey(config), controller); }
    remove(config: InternalRequestConfig) { const key = getPendingKey(config); pendingRequests.get(key)?.abort(); pendingRequests.delete(key); }
    removeAll() { pendingRequests.forEach((controller) => controller.abort()); pendingRequests.clear(); }
}
